import { AxiosError } from "axios";
import { axios } from "@moonscape/shared";

export const handleAPIKeySubmit = async ({
  profile,
  queryClient,
  values,
  setSubmitting,
  setErrorMsgs,
  refetch,
  email,
  setAddKeySuccess,
  setError,
  errorMsgs,
  onSuccess,
  onError,
  setIsSubmitting,
}) => {
  setIsSubmitting(true);

  console.log("values: ", values);
  const { exchange, accountId, blockchain, apiKey, apiSecret, apiPassword, label } = values;
  console.log("submitting formik", JSON.stringify(values, null, 2));
  // alert(JSON.stringify(values, null, 2));

  // reset the errorMsgs state to empty Set
  setErrorMsgs(new Set());

  /** flag to determine if settings page should trigger a sync on adding api
   * keys  */
  let shouldSync: boolean = false;

  // call axios post
  const data = {
    exchange: exchange,
    // Use blockchain field for wallet exchanges, fallback to accountId for other exchanges
    accountId: blockchain?.trim() || accountId?.trim(),
    apiKey: apiKey?.trim(),
    apiSecret: apiSecret?.trim(),
    password: apiPassword?.trim(),
    label: label?.trim(),
  };
  console.log("apikeys data", data);
  try {
    const resp = await axios.post("/apikeys", data);
    // alert(JSON.stringify(resp, null, 2))
    console.log(
      "[onSubmit] JSON.stringify(resp, null, 2)",
      JSON.stringify(resp, null, 2)
    );

    // Handle both old ("OK") and new (success: true) response formats
    const isSuccess = resp?.data === "OK" || resp?.data?.success === true;

    if (isSuccess) {
      console.log("[api key added]");

      // Check if this is a pending integration (API not yet active)
      const isPending = resp?.data?.pending ?? false;

      // refetch api keys to display up-to-date list in settings
      refetch();
      setAddKeySuccess(true);

      // Only trigger sync for active integrations, not pending ones
      shouldSync = !isPending;

      if (isPending) {
        console.log("[api key saved as pending integration]");
      } else {
        console.log("[api key validated and sync triggered]");
      }

      // toast.success("Exchange connected");

      setIsSubmitting(false);

      // Pass response data (including userGuidance and pending flag) to onSuccess callback
      onSuccess(resp?.data);
    }
  } catch (axiosError: AxiosError) {
    console.log("error formik", axiosError?.response?.data);

    setError(true);

    // Extract error message from response (supports both 'message' and 'errorMessage' fields)
    const errorData = axiosError?.response?.data;
    const errorMessage = errorData?.errorMessage || errorData?.message || errorData?.error;

    if (errorMessage) {
      const newErrorMsgs = new Set(errorMsgs);
      newErrorMsgs.add(errorMessage);
      setErrorMsgs(newErrorMsgs);
      console.log("[handleAPIKeySubmit] Error message:", errorMessage);
    }

    setIsSubmitting(false);
    onError(axiosError);
  }
  // formik - set to finish the form cycle
  setSubmitting(false);
  setIsSubmitting(false);

  // refresh all if demo is true
  if (profile?.isDemo && queryClient) {
    queryClient.invalidateQueries();
    console.log("[handleAPIKeySubmit] queryClient.invalidateQueries() called");
  }

  // return shouldSync
  return { shouldSync };
};
